export const WIDGET = {
  ID: {
    PARENT: "sign-widget-parent",
    MAIN: "sign-widget",
  },
} as const;
